/**
 * Dependencies.
 */
import StatusModel from '@/api/status/status.model';
import applicationConstant from '@/modules/main/constants/application.constant';
import { BaseService } from '@/modules/main/services/base.service';

/**
 * Service.
 */
class StatusService extends BaseService<StatusModel> {
  /**
   * Constructor.
   */
  constructor() {
    super(
      StatusModel,
      StatusModel.name,
      applicationConstant.apiCustomerPublicUrl
    );
  }

  /**
   * Get delivery tracking status.
   */
  getDeliveryTrackingStatus(): Promise<StatusModel[]> {
    const endpoint = `${this.getModelEndpoint}/deliveryTracking`;

    return this.GET(endpoint);
  }
}

/**
 * Export `statusService`.
 */
export const statusService = new StatusService();
